export const PIECE_JOINTE_TYPE_LOGO = 'Logo';
export const MODULE_CLIENT = 'Client';
export const MODULE_PRODUIT_UNITAIRE = 'ProduitUnitaire';
export const TAILLE_PJ_LIMITE = 10 * 1024 * 1024;
export const DIMENSION_MAX_LOGO = 1500;
export const QUALITE_JPEG_LOGO = 0.9;
